import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import SvgIcon from '../../icons/SvgIcon';

type Props = {
  currentIndex: number;
  numImages: number;
  onClose: () => void;
  invisible?: boolean;
};

export default function ListingImagesSingleImageFullScreenModalHeader({
  currentIndex,
  numImages,
  onClose,
  invisible,
}: Props) {
  return (
    <header
      className={twMerge(
        'flex flex-row items-center',
        invisible && 'invisible',
      )}
    >
      <button
        onClick={onClose}
        className="flex p-6 text-white hover:text-primary"
      >
        <SvgIcon name={'HiX'} className="h-10 w-10 text-white" />
      </button>
      <div className="flex-1 ">
        <p className="text-white text-center text-lg md:text-xl ">
          {currentIndex + 1} / {numImages}
        </p>
      </div>
      {/* this next div is just here for spacing/symmetry */}
      <div className="flex p-6">
        <SvgIcon name={'HiX'} className="h-10 w-10 invisible" />
      </div>
    </header>
  );
}
